
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statistiky",
      function () {
        return require("private-next-pages/statistiky/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statistiky"])
      });
    }
  